import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudRoleService} from '../../../../shared/services/crud-role.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService} from '@shared/services/alert.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {CrudAppdomainService} from '@shared/services/crud-appdomain.service';

@Component({
  selector: 'app-appdomain-edit',
  templateUrl: './appdomain-edit.component.html',
  styleUrls: ['./appdomain-edit.component.scss']
})
export class AppdomainEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected appdomainService: CrudAppdomainService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, appdomainService, alertService);

    // Create form fields
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'appclient',
                type: 'ng-select',
                defaultValue: 0,
                templateOptions: {
                  label: 'Client',
                  required: true,
                  closeOnSelect: true
                },
                hooks: {
                  onInit: this.initAppClient
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'url',
                type: 'input',
                templateOptions: { label: 'URL', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'system',
                type: 'input',
                templateOptions: {label: 'System', required: true}
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'active',
                type: 'checkbox',
                defaultValue: true,
                templateOptions: {label: 'Active'}
              }
            ]
          }
        ]
      }
    ];

    // Set form titles and entity path
    this.createSectionTitle = 'Create app domain';
    this.updatePrefixTitle = 'Edit app domain:';
    this.entityrooturl = '/admin/appdomains';
    this.labelFieldName = 'url';
  }

  /*
 * Form fields functions for dynamic values
 */
  initAppClient = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getClients();
    query.subscribe((data) => {
      typedField.templateOptions.options = data.results;
    });
  }

}
